import { render, staticRenderFns } from "./FishLoader.vue?vue&type=template&id=bb97660e&"
import script from "./FishLoader.vue?vue&type=script&lang=js&"
export * from "./FishLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports